<template>
  <div>
    <BaseToolbar
      :config="documentManagerToolBarConfig"
      @buttonClicked="documentManagerGridToolBarClick"
      v-show="DisplayDocManagerGrid"
    ></BaseToolbar>
    <BaseGrid
      :mode="'actionedit'"
      :excelExport="excelExport"
      :dropdownOptions="mgrGridOptions"
      :config="documentManagerGridConfig"
      @change="actionChanged"
      :query="mgrGridQuery"
      v-show="DisplayDocManagerGrid"
    ></BaseGrid>
    <br>
    <BaseDropzone
      :id="'drop'"
      @change="_change"
      @Remove="_remove"
      :File="inputfile"
      :UploadType="FileUploadType"
      v-show="displayDropZone"
    ></BaseDropzone>
    <br>
    <BaseToolbar
      :config="dropZoneToolBarConfig"
      @buttonClicked="dropZoneGridToolBarClick"
      v-show="DisplayFileUploadGrid"
    ></BaseToolbar>
    <BaseGrid
      :mode="'inline'"
      :excelExport="excelExport"
      :dropdownOptions="fileUploadGridOptions"
      :config="dropZoneGridConfig"
      :data="Files"
      v-show="DisplayFileUploadGrid"
    ></BaseGrid>
  </div>
</template>

<script>
import BaseGrid from "@/components/base/BaseGrid.vue";

import DocumentManagerGridConfig from "@/models/BaseModelDocument.js";
import DocumentManagerToolBarConfig from "@/models/BaseModelDocumentManagerToolBar.js";

import BaseDropzone from "@/components/base/BaseDropzone.vue";

import BaseToolbar from "@/components/base/BaseToolbar.vue";

import DropZoneGridConfig from "@/models/BaseModelDropZoneGrid.js";
import DropZoneToolBarConfig  from "@/models/BaseModelDropZoneToolBar.js";

import toolbarUtility from "@/services/toolbarUtility.js";
import apiutil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import JSZip from "jszip";

import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import {mapGetters, mapActions, mapState } from 'vuex';
import BaseModelInputControl from "@/models/BaseModelInputControl.js";

import _ from "lodash";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js"

export default {
  name: "DocumentDropoff",
  mixins: [toolbarUtility, apiutil, funcUtil,DocumentManagerMixin],
  watch: {
    "mgrGridQuery.filter": function(newVal) {
      //console.log("Inside Watcher")
      let grid = $("#DocumentManagerGrid").data("kendoGrid");
      grid.dataSource.read();
    }
  },
  computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
    DisplayFileUploadGrid() {
      return this.Files.length > 0 ? true : false;
    }
  },
  components: {
    BaseGrid,
    BaseDropzone,
    BaseToolbar
  },
  props: {
    mgrGridQuery: Object,
    //businessEvent: String,
    transactionRecord: Object,
    displayDropZone:{type: Boolean,default: true}
  },
  data: function() {
    return {
      documentManagerGridConfig: DocumentManagerGridConfig,
      documentManagerToolBarConfig: DocumentManagerToolBarConfig,
      DocumentGridMasterData: [],
      excelFormats: ["xlsx", "xlsb", "xlsm", "xls"],

      dropZoneGridConfig: DropZoneGridConfig,
      dropZoneToolBarConfig: DropZoneToolBarConfig,
      BaseModelProgram: BaseModelProgram,
      BaseModelInputControl: BaseModelInputControl,
      inputfile: {
        UploadFile: {}
      },
      FileUploadType: {
        AllowMultiple: true
      },
      Files: [],
      count: 1,
      fileUploadGridOptions: {},
      mgrGridOptions: {},
      DisplayDocManagerGrid: false
    };
  },

  methods: {
    ...mapActions("postModule",['UpdateItems','PostAllFilesAndUpdateMetadata','DeleteFile','DeleteAllFiles']),
  created(){
    console.log('-------------------BaseDropZone created-----------------------');
    _setVmInApiUtil(this.$root)
  },
    UpdateDocumentGridMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.DocumentGridMasterData = filterMasterData;
      } else {
        this.DocumentGridMasterData = $("#DocumentManagerGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
      this.DisplayDocManagerGrid= $("#DocumentManagerGrid").data("kendoGrid").dataSource.data().length>0 ? true: false

      //Hide Columns from Document Manger Grid
      if (this.transactionRecord.BusinessEvent=="Program" || this.transactionRecord.BusinessEvent=="Partner") {
        this._displayGridColumns("DocumentManagerGrid",{"PartnerTitle":"hide","BusinessEvent":"show"})
      }
      
    },
    dropZoneGridToolBarClick(e) {
      const self = this;
      let loader;

      let grid = $("#dropZoneGrid").data("kendoGrid");
      let selectedFileCount=0;

      if (e.id === "btnUpload") {
        let FileUpload = [];
        let flgSelected = true;
        let invalidFileName = "";

        grid.select().each(function() {
          if (
            grid.dataItem(this).DocumentType == "Please Select"
          ) {
            flgSelected = false;
            invalidFileName = invalidFileName + grid.dataItem(this).File + ", ";
          } else {
            //console.log(grid.dataItem(this));
            let selectedFile = { ...grid.dataItem(this) };
            selectedFile.BatchGUID=0

            if (self.transactionRecord.Type=="batch"){
              selectedFile.BatchGUID=self.transactionRecord.BatchGUID;
              selectedFile.PartnerIdList=self.transactionRecord.PartnerIdList;
              selectedFile.ProgramIdList=self.transactionRecord.ProgramIdList;
            }

            //Create Two records for Transfer Event 

            if ((selectedFile.BusinessEvent == "Transfer" ||(self.transactionRecord.CorrectionEventType && self.transactionRecord.CorrectionEventType=="Transfer")) 
            && !(self.transactionRecord.Type && self.transactionRecord.Type=="batch")) {
                //Create Another Record for Sender
                let senderObj = {};
                //senderObj.Id = this.count++;
                let fileName=selectedFile.File
                senderObj.File = fileName.substring(0, fileName.lastIndexOf('.')) + "-1" + fileName.substring(fileName.lastIndexOf('.'));
                senderObj.ProgramId = self.transactionRecord.ProgramId != undefined ? self.transactionRecord.ProgramId:null
                senderObj.ProgramTitle = selectedFile.ProgramTitle
                senderObj.PartnerTitle = self.transactionRecord.SenderFullName != undefined ? self.transactionRecord.SenderFullName:""
                senderObj.PartnerId = self.transactionRecord.SenderId != undefined ? self.transactionRecord.SenderId:null
                senderObj.BusinessEvent =(self.transactionRecord.CorrectionEventType)? "Correction": "Transfer"
                senderObj.TransactionID = selectedFile.TransactionID

                senderObj.DocumentType = selectedFile.DocumentType
                senderObj.Status = "Pending";
                senderObj.FileContent = selectedFile.FileContent
                //currentGridDataArray.push(senderObj);
                //console.log(senderObj);
                FileUpload.push(senderObj);
            }

            //console.log(selectedFile);
            //grid.saveChanges();

            FileUpload.push(selectedFile);
          }
          selectedFileCount++;
        });
        if (self.transactionRecord.Type=="batch") {
           console.log(`BaseDocumentMgrandDropoff.vue ... going to call this.UploadFilesToDB for Batch`);
          this.UploadFilesToDB(flgSelected,selectedFileCount,FileUpload,invalidFileName,
          "BaseDropZone","batch",self.transactionRecord.batchConfig,self.transactionRecord.parentGridId)

        }else{
          console.log(`BaseDocumentMgrandDropoff.vue ... going to call this.UploadFilesToDB for BaseDropZone`);
          this.UploadFilesToDB(flgSelected,selectedFileCount,FileUpload,invalidFileName,"BaseDropZone");

        }
        

      } else if (e.id === "btnDelete") {

        this.DeleteGridRows(grid, selectedFileCount);
        
      } else if (e.id === "btnReset") {
        //console.log("Reset Button Clicked");
        this.ResetGrid();
      }
      //this._baseToolBarEvents("dropZoneGrid", ...arguments);
    },
    _change(evt) {
      //When the Files are Uploaded in the Drop Zone. Need to take care of the existing data in the grid
      //TODO
      // 1. Get the grid data which user might have modified
      let currentGridDataArray = this.getCurrentDataFromGrid("dropZoneGrid");

      // 2. push the new files uploaded in the drop zone
      this.inputfile.UploadFile.forEach(obj => {
        let arrayobj = {};
        arrayobj.Id = this.count++;
        arrayobj.File = obj.name;
        arrayobj.ProgramTitle = this.transactionRecord.ProgramTitle != undefined ? this.transactionRecord.ProgramTitle:''
        arrayobj.PartnerTitle = this.transactionRecord.PartnerTitle != undefined ? this.transactionRecord.PartnerTitle:''
        arrayobj.ProgramId = this.transactionRecord.ProgramId != undefined ? this.transactionRecord.ProgramId:null
        arrayobj.PartnerId = this.transactionRecord.PartnerId != undefined ? this.transactionRecord.PartnerId:null
        arrayobj.BusinessEvent = this.transactionRecord.BusinessEvent != undefined ? this.transactionRecord.BusinessEvent:''
        arrayobj.TransactionID = this.transactionRecord.TransactionID != undefined ? this.transactionRecord.TransactionID:null

        arrayobj.DocumentType = "Please Select";
        arrayobj.Status = "Pending";
        arrayobj.FileContent = obj;
        currentGridDataArray.push(arrayobj);
      });
      this.Files = currentGridDataArray;

      console.log(this.Files);
    },
    _remove(evt) {
      console.log(this.inputfile.UploadFile);
    },
  },
  mounted() {
    let grid = $("#DocumentManagerGrid").data("kendoGrid");
    grid.bind("dataBound", this.UpdateDocumentGridMasterData);

    let filegrid = $("#dropZoneGrid").data("kendoGrid");
    filegrid.bind("dataBound", this.dropZoneGridDataBound);

    this.getInputControls("BaseDropZone");

    this._loadGridSettings("DocumentManagerGrid");
  }
};
</script>

<style>
.disableRow {
  opacity: 0.7;
  pointer-events: none;
}
</style>
